import { connect } from 'formik'
import { startCase } from 'lodash'
import { useIntl } from 'react-intl'
import JSONPretty from 'react-json-pretty'
import styled from 'styled-components'

import { FormLabel } from '@/components/StyledComponents'
import { BlockTitle } from '@/pages/SpaceAppBuilder/components/StyledComponents'
import messages from '@/pages/SpaceAppBuilder/FeaturesPage/Operations/messages'
import { ActionConfigExample, ActionConfigProps } from '@/pages/SpaceAppBuilder/utilities/interfaces'

import { Description } from './DataTransformOperation'

//<editor-fold desc="Styled Components">
const StyledContainer = styled.div`
  padding-top: 10px;
  padding-bottom: 20px;
`
const StyledTooltipLabel = styled(BlockTitle)`
  font-size: 0.8rem;
  font-weight: normal;
`
const StyledTooltipContainer = styled.div`
  min-width: 600px;
  max-height: 620px;
  padding: 0.5rem;
`
const StyledFormLabel = styled(FormLabel)`
  margin-top: 5px;
  display: block;
`
//</editor-fold>

const jsonPrettyTheme = {
  main: 'line-height:1.3;border-radius:4px;color:#000000;background:#f7f7f7;overflow:auto;margin: 5px 0px;',
  error: 'line-height:1.3;border-radius:4px;color:#000000;background:#f7f7f7;overflow:auto;margin: 5px 0px;',
  key: 'color:#116cb0;border-radius:4px;margin: 5px 0px;',
  string: 'color:#000000;border-radius:4px;margin: 5px 0px;',
  value: 'color:#000000;border-radius:4px;margin: 5px 0px;',
  boolean: 'color:#1f7615;border-radius:4px;margin: 5px 0px;'
}

const ActionTooltip = ({ actionConfig }: { actionConfig: ActionConfigProps }) => {
  const intl = useIntl()

  const { input, output } = actionConfig.example as ActionConfigExample
  return (
    <StyledTooltipContainer className="overflow-scroll">
      <Description>{actionConfig?.description}</Description>
      <StyledFormLabel>{intl.formatMessage(messages.dataTransformTooltipInput)}</StyledFormLabel>
      <StyledContainer>
        {input && (
          <>
            {input.parameters && (
              <>
                {Object.keys(input.parameters).map(paramKey => {
                  return (
                    <div key={paramKey}>
                      <StyledTooltipLabel>{startCase(paramKey)}</StyledTooltipLabel>
                      <JSONPretty theme={jsonPrettyTheme} data={input.parameters[paramKey]} />
                    </div>
                  )
                })}
                <StyledTooltipLabel>{intl.formatMessage(messages.dataTransformTooltipData)}</StyledTooltipLabel>
              </>
            )}
            <JSONPretty theme={jsonPrettyTheme} data={input.data} />
          </>
        )}
      </StyledContainer>

      <FormLabel>{intl.formatMessage(messages.dataTransformTooltipOutput)}</FormLabel>
      <JSONPretty theme={jsonPrettyTheme} data={output} />
    </StyledTooltipContainer>
  )
}
export default connect(ActionTooltip)
